/*
 * Given a number, will return a string padded with a zero on the left.
 *
 * E.g.
 * zeroPad(1) => 01
 * zeroPad(12) => 12
 * zeroPad(123) => 123
 * zeroPad(-1) => 01
 * zeroPad(-1.5) => 02
 */
export default (number: number) => {
  const num = Math.round(Math.abs(number))

  return num < 10 ? `0${num}` : `${num}`
}
